@if (loading) {
  <div class="loading-spinner"><mat-spinner diameter="50" color="accent"></mat-spinner></div>
} @else {
  @if (!events?.length) {
    <div class="no-result">{{ 'COMMON.HISTORY.NO_HISTORY' | translate }}</div>
  } @else {
    <vitamui-common-collapse [collapseTitle]="'COMMON.HISTORY.OPERATIONS' | translate">
      <vitamui-common-history-events [events]="events"></vitamui-common-history-events>
    </vitamui-common-collapse>
  }
}
